import {
  CREATE_CONNECT_ACCOUNT,
  CREATE_CONNECT_ACCOUNT_FAILED,
  CREATE_CONNECT_ACCOUNT_SUCCESS,
  GENERATE_CONNECT_LINK,
  GENERATE_CONNECT_LINK_FAILED,
  GENERATE_CONNECT_LINK_SUCCESS,
  GET_BALANCE,
  GET_BALANCE_FAILED,
  GET_BALANCE_SUCCESS,
  GET_EXPRESS_LINK,
  GET_EXPRESS_LINK_FAILED,
  GET_EXPRESS_LINK_SUCCESS,
  REDEEM_BALANCE,
  REDEEM_BALANCE_FAILED,
  REDEEM_BALANCE_SUCCESS,
  REFUND_BALANCE,
  REFUND_BALANCE_FAILED,
  REFUND_BALANCE_SUCCESS,
  SEND_INVOICE,
  SEND_INVOICE_FAILED,
  SEND_INVOICE_SUCCESS,
} from './constants';

const initialState = {
  availableBalance: 0,
  pendingBalance: 0,
  loginLink: undefined,
  isValid: false,
  error: null,
  loading: false,
  expressLink: undefined,
};

const balanceReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case GET_BALANCE:
    case CREATE_CONNECT_ACCOUNT:
    case GENERATE_CONNECT_LINK:
    case REDEEM_BALANCE:
    case GET_EXPRESS_LINK:
    case REFUND_BALANCE:
    case SEND_INVOICE:
      return { ...state, loading: true };
    case GET_EXPRESS_LINK_SUCCESS:
      return { ...state, loading: false, expressLink: action.payload.expressLink };
    case GET_BALANCE_SUCCESS:
      return {
        ...state,
        availableBalance: action.payload.available,
        pendingBalance: action.payload.pending,
        loginLink: action.payload.loginLink,
        isValid: action.payload.isValid,
        loading: false,
      };
    case REFUND_BALANCE_SUCCESS:
    case SEND_INVOICE_SUCCESS:
      return { ...state, loading: false };
    case CREATE_CONNECT_ACCOUNT_SUCCESS:
    case GENERATE_CONNECT_LINK_SUCCESS:
    case REDEEM_BALANCE_SUCCESS:
      return {
        ...state,
        availableBalance: state.availableBalance - action.payload.amount,
        loading: false,
      };
    case GET_BALANCE_FAILED:
    case CREATE_CONNECT_ACCOUNT_FAILED:
    case GENERATE_CONNECT_LINK_FAILED:
    case REDEEM_BALANCE_FAILED:
    case GET_EXPRESS_LINK_FAILED:
    case REFUND_BALANCE_FAILED:
    case SEND_INVOICE_FAILED:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    default:
      return state;
  }
};

export default balanceReducer;
